import { Injectable, OnDestroy } from '@angular/core';
import * as introJs from 'intro.js/intro.js';
import { LogementService } from "./logement.service";
import { Subscription } from "rxjs";
import {IntroJsOptions} from "./introjsOptions/intro.js.options";

@Injectable({
  providedIn: 'root'
})
export class IntroService implements OnDestroy {
  private introJs = introJs();
  private subscription: Subscription;

  constructor(
    private logementService: LogementService,
    private introJsOptions: IntroJsOptions
    ) {
  }

  start() {
    this.subscription = this.logementService.hasLogement().subscribe((hasLogement) => {
      if (hasLogement) {
        this.introJsOptions.getOptions()
          .subscribe(data => {
          this.intro(data);
        }).unsubscribe();
      }
    });
  }

  private intro(data) {
    const introAlreadySeen = localStorage.getItem('intro');
    const previsualisation = window.self !== window.top;
    if (introAlreadySeen || previsualisation) {
      return;
    }
    setTimeout(() => {
      const headerElement = document.getElementById('header');
      headerElement.style.position = 'absolute';
      this.introJs.setOptions(data).start();
      this.introJs.onbeforeexit(() => {
        headerElement.style.position = 'fixed';
      });
    });
    localStorage.setItem('intro', '1');
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
